import * as Output from '../../Text';

export const validateEmail = (field) => {
  const regexResult = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(field);
  if (!regexResult) {
    return Output.resolve(
      'generic.errors.M006_E-MailAddress',
    );
  }
  return undefined;
};
